import { CampaignTypeEnum, PreUploadRequirementEnum } from "@repo/graphql/gql/graphql";
import { RequirementProp } from "./types";

const ugcToUpload: () => RequirementProp[] = () => {
  return [
    {
      display: "El contenido deberá ser entregado a través de Montu.",
      value: PreUploadRequirementEnum.DeliveredInMontu,
    },
    {
      display:
        "El creador NO podrá subir el contenido a sus redes sociales, salvo autorización de la marca a través del chat.",
      value: PreUploadRequirementEnum.UploadedOnlyWithAuthorization,
    },
  ];
};

const meliToUpload: () => RequirementProp[] = () => {
  return [
    {
      display: "El contenido deberá ser entregado a través de Montu.",
      value: PreUploadRequirementEnum.DeliveredInMontu,
    },
    {
      display:
        "El creador NO podrá subir el contenido a sus redes sociales, salvo autorización de la marca a través del chat.",
      value: PreUploadRequirementEnum.UploadedOnlyWithAuthorization,
    },
  ];
};

const organicToUpload: () => RequirementProp[] = () => {
  return [];
};

export const campaignTypeToUploadRequirements: (
  campaignType: CampaignTypeEnum | null | undefined,
) => RequirementProp[] = (
  campaignType: CampaignTypeEnum | null | undefined,
) => {
  switch (campaignType) {
    case CampaignTypeEnum.Ugc:
      return ugcToUpload();
    case CampaignTypeEnum.Melicliips:
      return meliToUpload();
    case CampaignTypeEnum.Organic:
      return organicToUpload();
    default:
      return [];
  }
};
